import { Box, Button, Card, H1, Icon, Link, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import onDemandImage from '../../../../images/on_demand_billing.svg?url';
import urlBuilder from '../../../../Shared/url-builder';

const PROCESS_STEPS = ['Download and fill in the billing template', 'Resolve upload issues', 'Review and submit'];

export const OptInPage = () => {
  return (
    <Card>
      <Box css={{ borderRadius: 'medium', display: 'flex' }}>
        <Box
          css={{
            width: '413px',
            backgroundColor: 'primitives.gold.60',
          }}
        >
          <img
            src={onDemandImage}
            alt="On-demand billing"
            style={{
              width: '100%',
              height: '100%',
              padding: '35px',
              objectFit: 'contain',
            }}
          />
        </Box>

        <Box
          css={{
            py: 'space.400',
            px: '56px',
            display: 'flex',
            flexDirection: 'column',
            gap: 'space.600',
          }}
        >
          <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.400' }}>
            <Box>
              <H1
                color="text"
                variant="title200"
                css={{ fontSize: 'fontSize.300', lineHeight: '150%', pb: 'space.150' }}
              >
                Bill clients when you want.
              </H1>
              <Text
                as="span"
                variant="text100"
                css={{ fontSize: 'fontSize.100', fontWeight: '400', lineHeight: 'lineHeight.100' }}
              >
                On-demand billing lets you charge clients for services not included in their billing plans.{' '}
              </Text>
              <Link href="https://www.betterment.com/advisors/content-hub/client-billing" target="_blank">
                Learn more about how it works
              </Link>
            </Box>

            <Box>
              <Text
                as="span"
                css={{
                  fontWeight: '400',
                  fontSize: 'fontSize.100',
                  display: 'block',
                  pb: 'space.150',
                }}
              >
                Here's how the process works:
              </Text>
              <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.200' }}>
                {PROCESS_STEPS.map(step => (
                  <Box key={step} css={{ display: 'flex', gap: 'space.200', alignItems: 'center' }}>
                    <Icon color="dataviz.blue.2" name="CheckmarkCircle" size="small" />
                    <Text
                      as="span"
                      css={{
                        fontWeight: '400',
                        fontSize: 'fontSize.100',
                        lineHeight: '150%',
                        letterSpacing: 'normal',
                      }}
                    >
                      {step}
                    </Text>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>

          <SambaAutoLink to={urlBuilder.getOnDemandBillingStartPage.absolute()}>
            <Button variant="solidPrimary">Get started</Button>
          </SambaAutoLink>
        </Box>
      </Box>
    </Card>
  );
};
